import { GuestRoutesEnum } from 'routes/routes';
import { hasWindow } from './windowHelpers';
// There are times when we do not have access to the
// React Router hooks, so we need to use the window object to get the pathname
export const isGuestAppURL = () => {
  if (!hasWindow()) return false;
  const pathname = window.location.pathname;
  const splitPath = pathname.split('/');
  const isGuestApp = splitPath.includes(GuestRoutesEnum.home);
  return isGuestApp;
};
